import React from 'react';
import PropTypes from 'prop-types';

const PaymentListMessage = ({ children }) => (
  <div className="white-box item-box">
    <div className="inner">
      <p>{children}</p>
    </div>
  </div>
);

PaymentListMessage.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default PaymentListMessage;



// WEBPACK FOOTER //
// ./src/components/PaymentListMessage.js